export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14120.053b725d.jpg";